import { windowRange, type TypeWindowKey } from '@/function/calendar/calendar.window';
import { localDayKey } from '@/utils/date/day.key';

export const windowDays = (key: TypeWindowKey): { from: string; to: string } => {
    const range = windowRange(key);
    return { from: localDayKey(range.from), to: localDayKey(range.to) };
};

export default windowDays;
